import {
  List,
  Datagrid,
  TextField,
  EditButton,
  ReferenceInput,
  TextInput,
  usePermissions,
} from "react-admin";

const PaymentFilter = [
  <TextInput source="_q" label="Search" alwaysOn variant="outlined" />,
  <ReferenceInput source="payments" label="Payments" reference="payments" />,
];

export const PaymentsList = () => {
  const permissions = usePermissions();

  return (
    <List filters={PaymentFilter}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="id" />
        <TextField source="type" />
        {permissions.permissions === "Admin" ? <EditButton /> : ""}
      </Datagrid>
    </List>
  );
};
